
import Component from 'vue-class-component'
import Vue from 'vue'
import {Group} from '../models/group'
import {Assignment} from '../models/assignments'
import GridHeader from '../models/gridHeader'
import CardTable from '@/components/Layout/CardTable.vue'
import ConfirmationDialog from '@/components/Atomic/ConfirmationDialog.vue'
import GroupDetails from '../components/Groups/GroupDetails.vue'
import GroupForm from '../components/Groups/GroupForm.vue'
import AssignmentDetails from '../components/Groups/AssignmentDetails.vue'
import ToolTipButton from '../components/Atomic/ToolTipButton.vue'

import {INotificationService} from '../services/NotificationService'
import AssignmentService from '@/services/AssignmentService'
import GroupService from '@/services/GroupService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

@Component({
  components: {
    AssignmentDetails,
    CardTable,
    ConfirmationDialog,
    GroupDetails,
    GroupForm,
    ToolTipButton,
  },
})
export default class Groups extends Vue {
    public $refs!: {
    assignmentDetailsDialog: AssignmentDetails,
    groupDetailDialog: GroupDetails,
    groupFormDialog: GroupForm,
  }

private groups: Group[] = []
private assignments: Assignment[] = []
private headers: GridHeader[] = []
private isPending: boolean = false
private searchValue: string = ''
private $notificationService!: INotificationService
private errorHandlerService: ErrorHandlerService
private displayByGroup: 0 | 1 = 0

private async mounted() {
  this.errorHandlerService = new ErrorHandlerService()
  await this.createGroupHeaders()
  await this.fetchGroups()
}

private handleDialogClose() {
  this.onTableChange()
}

private async createGroupHeaders() {
  this.headers.push(new GridHeader(this.$t('Name').toString(), 'nom', 'left', true, 150))
  this.headers.push(new GridHeader(this.$t('Description').toString(), 'description', 'left', true, 150))
  this.headers.push(new GridHeader(this.$t('Email').toString(), 'courriel', 'left', true, 100))
  this.headers.push(new GridHeader(this.$t('SchoolSpecific').toString(), 'etablissement_specifique', 'center', true, 50))
  this.headers.push(new GridHeader(this.$t('Source').toString(), 'source', 'center', true, 50))
  this.headers.push(new GridHeader(this.$t('Actions').toString(), 'actions', 'center fixed', true, 50))
}

private async createGroupLinkHeaders() {
  this.headers.push(new GridHeader(this.$t('Name').toString(), 'name', 'left', true, 150))
  this.headers.push(new GridHeader(this.$t('Table').toString(), 'table', 'left', true, 150))
  this.headers.push(new GridHeader(this.$t('Actions').toString(), 'actions', 'center fixed', true, 50))
}

private get items() {
  return this.displayByGroup === 0 ? this.groups : this.assignments
}

private async fetchGroups() {
  try {
    this.isPending = true
    this.groups = await GroupService.get()
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
  } finally {
    this.isPending = false
  }
}

private async fetchGroupsAssignement() {
  try {
    this.isPending = true
    const assignments = await AssignmentService.get()
    this.isPending = false
    return assignments
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
    this.isPending = false
    return undefined
  }
}

private async deleteGroup(groupId: number) {
  try {
    this.isPending = true
    await GroupService.delete(groupId)
    this.$notificationService.success(this.$t('GROUPS.GroupDeleted').toString())
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
  } finally {
    this.isPending = false
    this.onTableChange()
  }
}

private async fetchGroupsDetailsAssignements(groupId: number) {
  try {
    const groupAssignments = await GroupService.fetchGroupDetailAssignment(groupId)
    return groupAssignments
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
    return undefined
  }
}

private async onClickGroupDetail(group: Group) {
  this.$refs.groupDetailDialog.show(group)
}

private async onClickCreateGroup() {
  this.$refs.groupFormDialog.show(undefined)
}

private async onClickAssignmentDetails(assignement: Assignment, readOnly: boolean) {
  this.$refs.assignmentDetailsDialog.show(assignement, readOnly)
}

private async onClickEditGroup(group: Group) {
  const clonedGroup = Object.assign({}, group)
  this.$refs.groupFormDialog.show(clonedGroup)
}

private async onTableChange() {
    this.searchValue = ''
    this.headers = []
    if (this.displayByGroup === 0) {
      this.createGroupHeaders()
      await this.fetchGroups()
    } else {
      this.createGroupLinkHeaders()
      const assignments = await this.fetchGroupsAssignement()
      this.assignments = assignments === undefined ? [] : assignments
    }
}

}
